/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_home_seo_rd_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove duplicate lines`)
};

const es_home_seo_rd_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar líneas duplicadas`)
};

const de_home_seo_rd_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppelte Zeilen entfernen`)
};

const nl_home_seo_rd_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijder dubbele regels`)
};

const fr_home_seo_rd_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer les lignes en doublon`)
};

const it_home_seo_rd_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi righe duplicate`)
};

const pt_br2_home_seo_rd_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover linhas duplicadas`)
};

const pt_home_seo_rd_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover linhas duplicadas`)
};

const ja_home_seo_rd_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重複行を削除する`)
};

const zh_home_seo_rd_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`去除重复行`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const home_seo_rd_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.home_seo_rd_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("home_seo_rd_title", locale)
	if (locale === "en") return en_home_seo_rd_title(inputs)
	if (locale === "es") return es_home_seo_rd_title(inputs)
	if (locale === "de") return de_home_seo_rd_title(inputs)
	if (locale === "nl") return nl_home_seo_rd_title(inputs)
	if (locale === "fr") return fr_home_seo_rd_title(inputs)
	if (locale === "it") return it_home_seo_rd_title(inputs)
	if (locale === "pt-BR") return pt_br2_home_seo_rd_title(inputs)
	if (locale === "pt") return pt_home_seo_rd_title(inputs)
	if (locale === "ja") return ja_home_seo_rd_title(inputs)
	return zh_home_seo_rd_title(inputs)
};